import type { LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";

import { Button } from "@krea/shared/design-system/Button";
import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";
import { cn } from "@krea/shared/utils";

interface IProps {
  Icon: LucideIcon;
  title: string;
  className?: string;
  iconClassName?: string;
  onClick: () => void;
}

const FileSectionAction = ({
  Icon,
  title,
  className,
  iconClassName,
  onClick,
  ...rest
}: IProps & ComponentProps<typeof Button>) => {
  return (
    <ResponsiveTooltip
      trigger={
        <Button
          variant={"ghost"}
          className={cn(
            "text-primary p-2 mr-0 sm:px-3 hover:bg-white",
            className,
          )}
          aria-label={title}
          onClick={onClick}
          {...rest}
        >
          <div
            className={cn(
              "size-[22px]",
              "flex items-center justify-center",
              iconClassName,
            )}
          >
            <Icon className="size-5" />
          </div>
        </Button>
      }
      className="gap-0!"
      interactive
      desktopOnly
    >
      {title}
    </ResponsiveTooltip>
  );
};

export default FileSectionAction;
